import React from 'react';
import GuestMyPage from '../../features/auth/GuestMyPage';
import { useUserStore } from '../../stores/userStore';
import UserProfilePage from './profile/UserProfilePage';

const MyPage = () => {
  const user = useUserStore((s) => s.user);
  const loading = useUserStore((s) => s.loading);
  if (!user) return loading ? null : <GuestMyPage />;
  return <UserProfilePage />;
};

export default MyPage;
